var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApplyCouponIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 16,
    viewBox: "0 0 21 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2857 7.99972C17.2857 6.54258 18.4 5.42829 19.8571 5.42829V1.14258L1 1.14258L1 5.42829C2.45714 5.42829 3.57143 6.54258 3.57143 7.99972C3.57143 9.45686 2.45714 10.5711 1 10.5711L1 14.8569L19.8571 14.8569V10.5711C18.4 10.5711 17.2857 9.45686 17.2857 7.99972Z",
    stroke: "#3371A5",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0003 5.42871L7.85742 10.5716",
    stroke: "#3371A5",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.28571 6.2853C8.99579 6.2853 9.57143 5.70966 9.57143 4.99958C9.57143 4.2895 8.99579 3.71387 8.28571 3.71387C7.57563 3.71387 7 4.2895 7 4.99958C7 5.70966 7.57563 6.2853 8.28571 6.2853Z",
    fill: "#3371A5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5718 12.2853C13.2819 12.2853 13.8576 11.7097 13.8576 10.9996C13.8576 10.2895 13.2819 9.71387 12.5718 9.71387C11.8618 9.71387 11.2861 10.2895 11.2861 10.9996C11.2861 11.7097 11.8618 12.2853 12.5718 12.2853Z",
    fill: "#3371A5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplyCouponIcon);
export default __webpack_public_path__ + "static/media/applyCouponIcon.297ec52df109d741f0d09923a24f169a.svg";
export { ForwardRef as ReactComponent };